import { Navigate, Route, Routes } from 'react-router-dom';
import { PublicLayout } from './components/public/PublicLayout';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { AppShell } from './components/layout/AppShell';
import { LandingPage } from './pages/LandingPage';
import { FeaturesPage } from './pages/FeaturesPage';
import { PricingPage } from './pages/PricingPage';
import { SecurityPage } from './pages/SecurityPage';
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { DashboardPage } from './pages/DashboardPage';
import { ItemsListPage } from './pages/ItemsListPage';
import { ItemDetailPage } from './pages/ItemDetailPage';
import { ActivityPage } from './pages/ActivityPage';
import { SettingsPage } from './pages/SettingsPage';
import { AdminDashboardPage } from './pages/AdminDashboardPage';
import { AdminUsersPage } from './pages/AdminUsersPage';
import { AdminSettingsPage } from './pages/AdminSettingsPage';
import { BillingPage } from './pages/BillingPage';
import { ReportPresetsPage } from './pages/ReportPresetsPage';
import { PropertiesPage } from './pages/PropertiesPage';
import { ReportsPage } from './pages/ReportsPage';

export default function App(): JSX.Element {
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<LandingPage />} />
        <Route path="/features" element={<FeaturesPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/security" element={<SecurityPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
      </Route>

      <Route element={<ProtectedRoute />}>
        <Route element={<AppShell />}>
          <Route path="/app" element={<DashboardPage />} />
          <Route path="/app/items" element={<ItemsListPage />} />
          <Route path="/app/items/:id" element={<ItemDetailPage />} />
          <Route path="/app/properties" element={<PropertiesPage />} />
          <Route path="/app/reports" element={<ReportsPage />} />
          <Route path="/app/report-presets" element={<ReportPresetsPage />} />
          <Route path="/app/activity" element={<ActivityPage />} />
          <Route path="/app/settings" element={<SettingsPage />} />
          <Route path="/app/settings/presets" element={<ReportPresetsPage />} />
          <Route path="/app/billing" element={<BillingPage />} />
          <Route path="/app/admin" element={<AdminDashboardPage />} />
          <Route path="/app/admin/users" element={<AdminUsersPage />} />
          <Route path="/app/admin/settings" element={<AdminSettingsPage />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
